export class RangeIntervalo {
  public de: number;
  public ate: number;
  public ignorar: boolean;
}
